<template>
  <v-dialog :value="open" persistent max-width="450px">
    <v-card>
      <v-card-text>
        <div class="d-flex pt-3 pb-3 flex-column align-center">
          <img src="/img/logo-pontofiq-recorte.png" class="loader-logo" alt="Logo" />
          <span class="pt-3 pb-3">{{ message }}</span>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    message: "",
    open: false,
  }),
  mounted() {
    this.$loaderService.setOpenFunction((message) => this.openModal(message));
    this.$loaderService.setCloseFunction(() => (this.open = false));
  },
  methods: {
    openModal(message) {
      this.open = true;
      this.message = message;
    },
  },
};
</script>

<style>
.loader-logo {
  height: 90px;
  width: auto;
  object-fit: contain;
}

/* O logo é roxo escuro: no modo escuro ganha uma placa clara. */
.theme--dark .loader-logo {
  box-sizing: content-box;
  padding: 8px 14px;
  border-radius: 14px;
  background: linear-gradient(145deg, #f5f0ff 0%, #ffffff 100%);
}
</style>
